import React from 'react';
import { Box, Stack, Slider, Typography, IconButton } from '@mui/material';
import OpacityIcon from '@mui/icons-material/Opacity';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';

export default function ControlsOverlay({
  silhouetteScale,
  silhouetteOpacity,
  transformHistory,
  transformFuture,
  onUndo,
  onRedo,
  onScaleChange,
  onOpacityChange,
}) {
  return (
    <Box 
      sx={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        p: 1.5,
        background: 'rgba(0,0,0,0.55)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255,255,255,0.10)',
        borderRadius: 2,
        zIndex: 20,
        minWidth: '120px'
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box>
          <Stack direction="row" spacing={1} justifyContent="center">
            <IconButton
              size="small"
              onClick={onUndo}
              disabled={transformHistory.length === 0}
              sx={{ color: 'white', '&.Mui-disabled': { color: 'rgba(255,255,255,0.3)' } }}
              aria-label="undo"
            >
              <UndoIcon fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              onClick={onRedo}
              disabled={transformFuture.length === 0}
              sx={{ color: 'white', '&.Mui-disabled': { color: 'rgba(255,255,255,0.3)' } }}
              aria-label="redo"
            >
              <RedoIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Box>
        <Box>
          <Stack spacing={0.5} direction="row" alignItems="center">
            <ZoomInIcon sx={{ color: 'white', fontSize: '1rem' }} />
            <Typography gutterBottom sx={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.8rem', m:0 }}>Scale: {Math.round(silhouetteScale * 100)}%</Typography>
          </Stack>
          <Slider
            size="small"
            aria-label="Scale"
            value={silhouetteScale}
            onChange={onScaleChange}
            min={0.1}
            max={3}
            step={0.05}
            valueLabelDisplay="auto"
            sx={{ color: '#7C3AED', '& .MuiSlider-thumb': { backgroundColor: 'white' }, '& .MuiSlider-rail': { opacity: 0.4 }, '& .MuiSlider-track': { opacity: 0.8 } }}
          />
        </Box>
        <Box>
          <Stack spacing={0.5} direction="row" alignItems="center">
            <OpacityIcon sx={{ color: 'white', fontSize: '1rem' }} />
            <Typography gutterBottom sx={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.8rem', m:0 }}>Opacity: {Math.round(silhouetteOpacity * 100)}%</Typography>
          </Stack>
          <Slider
            size="small"
            aria-label="Opacity"
            value={silhouetteOpacity}
            onChange={onOpacityChange}
            min={0}
            max={1}
            step={0.05}
            valueLabelDisplay="auto"
            sx={{ color: '#7C3AED', '& .MuiSlider-thumb': { backgroundColor: 'white' }, '& .MuiSlider-rail': { opacity: 0.4 }, '& .MuiSlider-track': { opacity: 0.8 } }}
          />
        </Box>
      </Box>
    </Box>
  );
}
